import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  mobileMenuShown: false
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    toggleMobileMenu: (state, action) => {
      if (action.payload === undefined) {
        state.mobileMenuShown = !state.mobileMenuShown;
      } else {
        state.mobileMenuShown = action.payload;
      }
    }
  }
});

export const {
  toggleMobileMenu: rxToggleMobileMenu
} = settingsSlice.actions;

export const settingsSelector = state => state.settings;

export default settingsSlice.reducer;
